import CryptoJS from "crypto-js";
import { getTabID } from "./storage";

// SECURITY NOTE: This key is a fixed string hardcoded in the frontend bundle.
// It is used only for the tab-ID encryption layer (setTabID / getTabID).
// It is visible to any user who inspects the browser bundle.
const FIXED_KEY = "kyt_3b_1d_1ky";

/* ======= URL-safe Base64 helpers ======= */
const urlSafeBase64Encode = (value) =>
  btoa(value).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const urlSafeBase64Decode = (value) => {
  let v = value.replace(/-/g, "+").replace(/_/g, "/");
  while (v.length % 4) v += "=";
  return atob(v);
};

/* ======= Dynamic-key encryption (key = tab ID) ======= */

export const encryptObject = (value) => {
  const data = JSON.stringify(value);
  const encrypted = CryptoJS.AES.encrypt(data, getTabID()).toString();
  return urlSafeBase64Encode(encrypted);
};

export const decryptObject = (textToDecrypt) => {
  const decrypted = urlSafeBase64Decode(textToDecrypt);
  const bytes = CryptoJS.AES.decrypt(decrypted, getTabID());
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};

export const encryptString = (value) =>
  CryptoJS.AES.encrypt(value.toString(), getTabID()).toString();

export const decryptString = (textToDecrypt) => {
  if (textToDecrypt) {
    const bytes = CryptoJS.AES.decrypt(textToDecrypt, getTabID());
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  return null;
};

/* ======= Fixed-key encryption (key = FIXED_KEY, used for tab ID) ======= */

export const encryptStringTID = (value) =>
  CryptoJS.AES.encrypt(value.toString(), FIXED_KEY).toString();

export const decryptStringTID = (textToDecrypt) => {
  if (textToDecrypt) {
    const bytes = CryptoJS.AES.decrypt(textToDecrypt, FIXED_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  return null;
};
